// 'use strict';
import $ from '@nuskin/nuskinjquery';
import angular from 'angular';

import '../app.js';
import {UserService, AccountManager, AuthenticationService} from '@nuskin/ns-account';
import {
    RunConfigService,
    // StringService,
    storage,
    events,
    StickyHeaderStack,
    StickyHeader,
    util,
    SponsorStorageService,
    StoreFrontSponsorStorageService,
    PersonalOfferStorageService,
    nuskin,
    ShoppingContext,
    UrlService
} from '@nuskin/ns-util';
import {
    AccertifyFraudService,
    AgreementService,
    CartService,
    ShopContextService,
    AdrService,
    PaymentType,
    PersonalOfferService,
    CheckoutModeService,
    OrderManager,
    PickupUtil,
    ExternalPaymentService
} from '@nuskin/ns-shop';
import AdrUtil from '../util/adrUtil';
import CartUtil from '../util/cartUtil';
import DropShipUtil from '../util/dropShipUtil';
import ModalUtil from '../util/modalUtil';
import OrderUtil from '../util/orderUtil';
import PaymentUtil from '../util/paymentUtil';
import SectionUtil from '../util/sectionUtil';
import ShippingAddressUtil from '../util/shippingAddressUtil';
import {getStrings} from '../util/stringUtil';
import ThreatMatrixUtil from '../util/threatMatrixUtil';
import PromoCodeOffers from '../util/promoCodeOffers';
import {retrieveProductionToggles, isEnabled} from '@nuskin/ns-feature-flags';
import {getCachedConfigurations, getCachedConfigField} from '@nuskin/configuration-sdk';

const MAINTENANCE_BYPASS = 'maintenanceBypass';

angular.module('checkout').controller('OrderSummaryCtrl', ['$window', '$scope', '$rootScope', '$filter', '$q', '$http',
    '$location', '$timeout', 'nsAdrOptions', 'nsShipping', 'nsTimeDelivery', 'nsPayment', 'nsUtil',
    'nsSections', 'nsDowntime', 'nsADRType', 'nsAdrUtil',
    async function($window, $scope, $rootScope, $filter, $q, $http, $location, $timeout, nsAdrOptions, nsShipping, nsTimeDelivery, nsPayment, nsUtil, nsSections, nsDowntime, nsADRType, nsAdrUtil) {    // eslint-disable-line
        const initCheckout = async () => {
            // If the locale in the route does not match what is in the runconfig then the
            // page needs to be reloaded. This can happen when the locale is change in the
            // route by hand.
            $scope.runConfig = RunConfigService.getRunConfig();
            const [language, country] = UrlService.getLocaleFromUrl();
            if (language != $scope.runConfig.language || country != $scope.runConfig.country) {
                // This will likely be if the url does not have the locale on it which is likely
                // because the route is missing.  This will cause it to go to the last locale used.
                const locale = language && country ? `${language}_${country}` : `${$scope.runConfig.language}_${$scope.runConfig.country}`;
                window.location.hash = `#/${locale}/orderSummary`;
                window.location.reload();
                return;
            }

            // The native app shows its own header and footer
            if (window.ReactNativeWebView) {
                $scope.hideHeader = true;
                $scope.hideFooter = true;
            }

            // If the route or page changes publish any analytics changes
            $rootScope.$on('$locationChangeStart', function(event, next, current) {
                // make sure the function is defined before calling it
                if (typeof $scope.publishShippingMethodChangeCount === 'function') {
                    $scope.publishShippingMethodChangeCount();
                }
            });
            window.addEventListener('beforeunload', function() {
                // make sure the function is defined before calling it
                if (typeof $scope.publishShippingMethodChangeCount === 'function') {
                    $scope.publishShippingMethodChangeCount();
                }
            });

            const {Checkout: checkoutCfg, ADP: adpCfg, Shopping: shopCfg, Url: urlCfg} =
                getCachedConfigurations(['Checkout', 'ADP', 'Shopping', 'Url']);

            $scope.storefrontSponsor = StoreFrontSponsorStorageService.getStoreFrontSponsor();

            const veraData = JSON.parse(localStorage.getItem('skin-consultation-vuex-state')) || {};
            const isCorporateSponsor = veraData.app && veraData.app.isCorporateSponsor;
            const appropriateContext = ShoppingContext.isContext(ShoppingContext.STOREFRONT) ||
                ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT) ||
                ShoppingContext.isContext(ShoppingContext.PERSONAL_OFFER) ||
                ShoppingContext.isContext(ShoppingContext.PRODUCT_OFFER);
            $scope.useMySiteFooterAndHeader = !isCorporateSponsor && appropriateContext;
            $scope.storefrontHeaderLogo = $scope.storefrontSponsor && $scope.storefrontSponsor.siteLogo ? $scope.storefrontSponsor.siteLogo : '';

            $scope.getItemCnt = () => {
                return $scope.order ? $scope.order.sapItemQty : 0;
            };

            $scope.shipMethodAccordionClicked = () => {
                if (!$scope.isBusy && !$scope.sections.shipmethod.pristine) {
                    if ($scope.sections.shipmethod.edit) {
                        if (!$scope.shouldSelectPickupPoint() && !$scope.sections.shipmethod.error.hasErrorMessages()) {
                            // Collapse accordion
                            $scope.continueEdit('shipmethod');
                        }
                    } else {
                        $scope.updateEdit('shipmethod');
                    }
                }
            };

            $scope.adrAccordionClicked = () => {
                if (!$scope.isBusy && !$scope.sections.adrOptions.pristine) {
                    if ($scope.sections.adrOptions.edit) {
                        $scope.continueEdit('adrOptions');
                    } else {
                        $scope.updateEdit('adrOptions');
                    }
                }
            };

            // Returns true if the product's price list includes a points price and the item is not ADR, false otherwise
            $scope.hasPointsPrice = (item) => (Number.isFinite(item.points) && !item.isAdr);

            // Returns the total points price for this item
            // (e.g. item that costs 4.5 pts each, user is purchasing 3 with points -> item points subtotal = 4.5 * 3 = 13.5 pts)
            $scope.getItemSubtotalPoints = (item) => item.qtyRedeemWithPoints * item.points;

            $scope.getItemUnitPrice = (sapItem) => {
                let unitPrice = 0;

                if (sapItem.price > 0) {
                    // calculate based off of simulate. Should not be a divide by 0 since lineItem price > 0. (qty > qtyRedeemWithPoints
                    unitPrice = sapItem.price / (sapItem.qty - sapItem.qtyRedeemWithPoints);
                } else {
                    // can't base it off of simulate, use cart unit price.
                    CartService.getItemData({cartItems: true})
                        .filter((item) => item.sku === sapItem.sku)
                        .forEach((item) => {
                            unitPrice = item.price;
                        });
                }

                return unitPrice;
            };

            // Handle points allocation for line items with quantity = 1
            $scope.syncSingleItemRedeem = (item) => {
                if ($scope.showPointsPaymentOptions && validatePointsChange(item, item.redeem ? item.qty : 0)) {
                    updateDomItemPricing(item, item.redeem ? item.qty : 0);
                    $scope.updateEdit('cart');
                } else {
                    item.redeem = false;
                }
            };

            // Handle points allocation for line items with quantity > 1
            $scope.updatePtsForMultipleQtyItem = (item, usePoints) => {
                if ($scope.showPointsPaymentOptions && validatePointsChange(item, usePoints ? 1 : 0)) {
                    if (usePoints) {
                        item.redeem = true;
                        updateDomItemPricing(item, 1);
                    } else {
                        item.redeem = false;
                        updateDomItemPricing(item, 0);
                    }
                    $scope.updateEdit('cart');
                } else {
                    item.redeem = false;
                }
            };

            $scope.decreaseQtyRedeem = (item) => {
                if ($scope.showPointsPaymentOptions && validatePointsChange(item, item.qtyRedeemWithPoints - 1)) {
                    if (item.qtyRedeemWithPoints > 1) {
                        updateDomItemPricing(item, item.qtyRedeemWithPoints - 1);
                    }
                }
            };

            $scope.increaseQtyRedeem = (item) => {
                if ($scope.showPointsPaymentOptions && validatePointsChange(item, item.qtyRedeemWithPoints + 1)) {
                    if (item.qtyRedeemWithPoints < item.qty) {
                        updateDomItemPricing(item, item.qtyRedeemWithPoints + 1);
                    }
                }
            };

            /**
             * This is the ng-click event function for the points Continue button.
             * Simulate order then reset (un-pristine) the points fields.
             *
             * @param {boolean} disabled
             */
            $scope.pointsContinueClicked = (disabled = false) => {
                if (disabled) {
                    return;
                }

                if ($scope.pointsEdited) {
                    $scope.simulateOrder().then(function() {
                        $scope.continueEdit('cart');
                        $scope.pointsEdited = false;
                    });
                } else {
                    $scope.continueEdit('cart');
                }
            };

            $scope.updateQtyRedeem = (item) => {
                if (!$scope.showPointsPaymentOptions || !item.redeem) {
                    return;
                }

                let newQtyRedeem = Math.floor(item.qtyRedeemWithPoints || 0);
                newQtyRedeem = Math.floor(newQtyRedeem || 0);
                newQtyRedeem = newQtyRedeem > item.qty ? item.qty : newQtyRedeem;
                newQtyRedeem = newQtyRedeem < 1 ? 1 : newQtyRedeem;
                if (validatePointsChange(item, newQtyRedeem)) {
                    updateDomItemPricing(item, newQtyRedeem);
                }
            };

            /**
             * Sets the quantity to redeem with points on the item, and updates the item
             * price, cart subtotal price, and grand total price accordingly.
             *
             * @param {updateDomItemPricing} sapItem
             * @param {number} qtyRedeem
             */
            function updateDomItemPricing(sapItem, qtyRedeem) {
                CartService.getItemData({cartItems: true})
                    .filter((cartItem) => cartItem.sku === sapItem.sku)
                    .forEach((cartItem) => {
                        const {deltaItemTotal, sapItemData} = CartService.updateItemPointsPrice(sapItem.key, cartItem.key, qtyRedeem);

                        // update local sapItem with new information
                        Object.assign(sapItem, sapItemData);

                        $scope.order.orderTotals.itemSubtotal += deltaItemTotal;
                        $scope.order.orderTotals.grandTotal += deltaItemTotal;
                        $scope.cartPointsSubtotal = getPointsPriceTotal(false);
                        $scope.pointsTotal = getPointsPriceTotal();
                    });

                $scope.order.orderTotals.psvTotal = getPsvTotal();
            }

            /**
             * getPsvTotal
             *
             * @return {number}
             */
            function getPsvTotal() {
                let psvRunningTotal = 0;

                CartService.getItemData({sapItems: true})
                    .forEach((sapItem) => {
                        // update psv
                        psvRunningTotal += (sapItem.qty - sapItem.qtyRedeemWithPoints) * CartService.getItemUnitPsv(sapItem.key);
                    });

                return psvRunningTotal;
            }

            /**
             * validatePointsChange
             *
             * @param {String} sapItem
             * @param {number} newQtyRedeem
             * @return {boolean}
             */
            function validatePointsChange(sapItem, newQtyRedeem) {
                const pointsDiff = (sapItem.points * newQtyRedeem) - (sapItem.points * (sapItem.qtyRedeemWithPoints || 0));
                const singlePsv = CartService.getItemUnitPsv(sapItem.key);
                const psvDiff = ((singlePsv * newQtyRedeem) - (singlePsv * sapItem.qtyRedeemWithPoints || 0)).toFixed(2);
                let retVal = false;

                $scope.pointsEdited = true;

                // Skip validation if user's points balance not yet initialized
                if (!$scope.showPointsPaymentOptions || $scope.userAvailablePoints === null) {
                    return;
                }

                if ($scope.pointsTotal + pointsDiff > $scope.userAvailablePoints) {
                    addValidationMessage($scope.tdc.userPointsExceededError);
                } else if (!(AdrService.isAdrOverride() && !(adpCfg.psvRequiredOnOrder)) && getOrderTotalPsv() - psvDiff <= 0) {
                    addValidationMessage($scope.tdc.zeroPsvError);
                } else {
                    removeValidationMessage();
                    retVal = true;
                }

                /**
                 * addValidationMessage
                 *
                 * @param {string} message
                 */
                function addValidationMessage(message) {
                    const domHasMessage = $scope.sections.cart.error.infoMessages
                        .some((msg) => msg.text === message);
                    if (!domHasMessage) {
                        $scope.sections.cart.error.addErrorMessage('info', {text: message});
                    }
                }

                /**
                 * removeValidationMessage
                 */
                function removeValidationMessage() {
                    const leftOverMessages = $scope.sections.cart.error.infoMessages
                        .filter((item) => item.text !== $scope.tdc.userPointsExceededError && item.text !== $scope.tdc.zeroPsvError);

                    $scope.sections.cart.error.infoMessages = [];
                    leftOverMessages.forEach((message) => $scope.sections.cart.error.addErrorMessage('info', {text: message}));
                }

                return retVal;
            }

            /**
             * getOrderTotalPsv
             *
             * @return {string}
             */
            function getOrderTotalPsv() {
                return parseFloat(CartService.getItemData({cartItems: true})
                    .filter((item) => (item.isAdr && $scope.adr.shipImmediate) || (!item.isAdr))
                    .map((item) => {
                        return item.singlePv * (item.qty - (item.qtyRedeemWithPoints || 0));
                    })
                    .reduce((a, b) => a + b, 0))
                    .toFixed(2);
            }

            /**
             * Acquire the total points.
             *
             * @param {boolean} applyShipping - to the total point price. True by default.
             * @return {number} the point price total
             */
            function getPointsPriceTotal(applyShipping = true) {
                if (!$scope.order) {
                    return 0.0;
                }
                const productsTotal = CartService.getItemData({sapItems: true})
                    .filter((item) => !!item.points)
                    .map((item) => {
                        const qtyRedeem = item.qtyRedeemWithPoints > 0 ? item.qtyRedeemWithPoints : item.redeem ? item.qty : 0;
                        return item.points * qtyRedeem;
                    })
                    .reduce((a, b) => a + b, 0);
                let pointsShippingCost = 0;
                if (nuskin.configuration.adpManage && nuskin.configuration.adpManage.PayWithPointsShippingCost) {
                    pointsShippingCost = Number.parseInt(nuskin.configuration.adpManage.PayWithPointsShippingCost);
                }
                return productsTotal + (($scope.order.shippingPayWithPoints && applyShipping) ? pointsShippingCost : 0);
            }

            /**
             * resetPointsAllocations
             */
            function resetPointsAllocations() {
                if ($scope.showPointsPaymentOptions) {
                    CartService.getItemData({sapItems: true})
                        .filter((item) => item.redeem)
                        .forEach((item) => {
                            updateDomItemPricing(item, 0);
                        });
                    $scope.order.shippingPayWithPoints = false;
                }
            }

            /**
                 * This will add custom script and style tags in the context config to the page specified
                 * You need to add the following configs to your context config to your page
                 *
                 * custom${pageName}ScriptUrl
                 * custom${pageName}Script
                 * custom${pageName}StyleUrl
                 * custom${pageName}Styles
                 *
                 *  @param {string} pageName  Required
                 */
            function loadCustomJSStylesOnPage(pageName) {
                if (checkoutCfg.customCheckoutScriptUrl) {
                    const scriptEle = document.createElement('script');
                    scriptEle.type = 'text/javascript';
                    scriptEle.setAttribute('src', checkoutCfg.customCheckoutScriptUrl);
                    document.head.appendChild(scriptEle);
                }

                if (checkoutCfg.customCheckoutStyleUrl) {
                    const styleEle = document.createElement('style');
                    styleEle.type = 'text/css';
                    styleEle.setAttribute('src', checkoutCfg.customCheckoutStyleUrl);
                    document.head.appendChild(styleEle);
                }
                if (checkoutCfg.customCheckoutStyles) {
                    const styleEle = document.createElement('style');
                    styleEle.type = 'text/css';
                    styleEle.appendChild(document.createTextNode(checkoutCfg.customCheckoutStyles));
                    document.head.appendChild(styleEle);
                }
            }

            $scope.isPWPShippingMethod = (selectedMethod) => {
                const adpManage = nuskin.configuration.adpManage;
                if (!adpManage || !adpManage.enablePayWithPoints || !adpManage.PayWithPointsShippingMethods) {
                    return false;
                }
                if (!selectedMethod || !selectedMethod.Code) {
                    return false;
                }
                return adpManage.PayWithPointsShippingMethods.indexOf(selectedMethod.Code) > -1;
            };

            $scope.onTogglePWPShipping = () => {
                $scope.pointsTotal = getPointsPriceTotal();

                if ($scope.pointsTotal > $scope.userAvailablePoints) {
                    $scope.order.shippingPayWithPoints = false;
                    $scope.pointsTotal = getPointsPriceTotal();

                    // Add user error message if not already present
                    const hasPtsExceededError = $scope.sections.review.error.errorMessages
                        .some((msg) => msg.text === $scope.tdc.userPointsExceededError);
                    if (!hasPtsExceededError) {
                        $scope.sections.review.error.addErrorMessage('error', {text: $scope.tdc.userPointsExceededError});
                    }
                }
            };

            $scope.showCheckout = storage.getItem(storage.metadata.RECEIVING_ITEMS) !== true;
            const EXTERNAL_PAYMENT_NEXT_ORDER = 'externalPaymentNextOrder';
            if (!$scope.showCheckout) {
                return;
            }

            $scope.forms = {};

            // Provide a default landing page if needed.
            if (!$scope.runConfig.landing) {
                $scope.runConfig.landing = CartService.getCheckoutPage({route: 'orderSummary'});
            }

            $scope.user = UserService.getUser();

            // TODO: This is for SEA Shoppe which is not used anymore
            // try {
            //     $scope.editMode = checkoutSetup.editMode;
            //     $scope.bruneiName = checkoutSetup.bruneiName;
            //     $scope.indonesiaName = checkoutSetup.indonesiaName;
            //     $scope.malaysiaName = checkoutSetup.malaysiaName;
            //     $scope.philippinesName = checkoutSetup.philippinesName;
            //     $scope.singaporeName = checkoutSetup.singaporeName;
            //     $scope.thailandName = checkoutSetup.thailandName;
            // }
            // // If checkoutSetup is not set up:
            // catch (err) {
            //     console.error(err.message);
            // }

            $scope.saveSAPAddresstoProfile = false;

            $scope.getCartParams = function(params = {}) {
                params.isMySite = StoreFrontSponsorStorageService.getStoreFrontSponsor() && SponsorStorageService.getSponsor();
                return params;
            };

            const showShipWhen = await nsAdrUtil.showAdrShipWhen();
            if (showShipWhen) {
                CartService.goToCheckoutPage({route: 'adrShipWhen'});
                return;
            }

            // ---------------------------------------------
            //
            //        Private Variables
            //
            // ---------------------------------------------
            const user = $scope.user;
            // ---------------------------------------------
            //
            //        Public Variables
            //
            // ---------------------------------------------

            loadCustomJSStylesOnPage('Checkout');
            $scope.showEventMessageModal = false;
            if (nuskin.util.MobileUtils.isMobileLike() || window.innerWidth < 1337) {
                $scope.pickupMapSelected = true;
            }
            $scope.tdc = await getStrings();
            $scope.PaymentType = PaymentType;
            $scope.hasEventItems = CartService.hasEventItems();
            $scope.isPitchCart = !!CartService.getCartProperty('isPitchCart');
            if (StoreFrontSponsorStorageService.getStoreFrontSponsor() && SponsorStorageService.getSponsor() && !$scope.isPitchCart) {
                $scope.isStorefrontCart = true;
            } else {
                $scope.isStorefrontCart = false;
            }
            $scope.isGuestCheckout = CheckoutModeService.isGuestCheckout();
            $scope.hidePointValue = false;
            $scope.isGift = !!CartService.getCartProperty('isGift');

            $scope.chosen = {};
            $scope.chosen.element = null;
            $scope.chosen.isValid = false;

            $scope.globalHeader = null;
            $scope.errorHeader = null;
            $scope.paymentIsWire = false;

            $scope.deleteShippingDialogId = null;
            $scope.deletePaymentDialogId = null;
            $scope.emailOptIn = false;
            $scope.stickySideBar = {value: false};
            $scope.slideUpOrderReview = false;
            $scope.isIOS = nuskin.util.MobileUtils.isIOS();
            $scope.googleMapsChanged = false;
            $scope.storedCredentialsDialog = false;
            $scope.paymentPref = storage.getItem(storage.metadata.PAYMENT_PREF);
            $scope.showDownConvertTncCheckbox = false;
            $scope.downConvertTncChecked = false;

            // The following properties on scope should not be modified in a isolate scope directive
            $scope.contentLoaded = false;
            $scope.showSpinner = true;
            $scope.shippingBusy = false;
            $scope.buyForOther = false;
            $scope.isBusy = false;
            $scope.forceDisableOrderButton = false;
            $scope.backdatingToggle = false;

            $scope.usedPoints = CartService.getCartInfo().totalOrderPoints;
            $scope.showPsv = ShopContextService.showPsv($scope.user ? $scope.user.accountType : 0) && !$scope.isGuestCheckout;

            $scope.showPointsPaymentOptions = false;
            $scope.detailsIcon = 'nuskin:icon-smallcart-empty';
            $scope.userAvailablePoints = null;
            $scope.pointsTotal = 0;
            $scope.blockPointsPromoCombo = false;

            // Health warnings required by California for orders containing applicable SKUs
            $scope.californiaWarnings = null;

            $scope.translations = {
                loyalty: {
                    enjoyCreditsLabel: '', summaryEarningsLabel: '', summaryRedeemedLabel: ''
                },
                payment: {
                    agreeToTermsOfUseMessage: '', termsOfUse: ''
                }
            };

            getAgreedToTermsFlag($scope.user);

            $scope.getTranslation = () => {
                // angular.forEach($scope.translations, (object, applicationKey) => {
                //     StringService.getApplicationStrings(applicationKey).then((response) => {
                //         $scope.translations[applicationKey] = response;
                //         $scope.apply();
                //     });
                // });
            };
            $scope.getTranslation();

            if ($scope.isPitchCart) {
                $scope.personalOffer = PersonalOfferStorageService.getPersonalOffer();
            }

            SectionUtil.initSections($scope, nsSections, $timeout);

            const hideProcessingIndicators = function() {
                $('#mobile-processing').hide();
                $scope.isBusy = false;
            };

            // If authentication is required and the user is not authenticated we redirect back to the cart with a force login.
            if (shopCfg.authenticationRequired) {
                let redirectToCartPage = false;

                if (UserService.isLTOSite()) {
                    if (!AuthenticationService.isLoggedIn()) {
                        redirectToCartPage = true;
                    }
                } else if (!AccountManager.isLoggedIn() && !$scope.isGuestCheckout) {
                    redirectToCartPage = true;
                }

                if (redirectToCartPage) {
                    CartService.goToCartPage($scope.getCartParams({hashParams: 'forceLogin'}));
                    return;
                }
            }

            // We need the adr ship days changed listener initialized here first
            initListeners();

            // Redirect to order confirmation if we have received a successful externalPayment
            const needToHandleExternalPayment = ExternalPaymentService.needToHandleExternalPayment();
            // Need to initialize adrUtil first so $scope.adr is defined before handling external payment
            await AdrUtil.initAdrUtil($scope, nsAdrOptions, $timeout, nsADRType, nsAdrUtil, needToHandleExternalPayment);
            if (needToHandleExternalPayment) {
                hideProcessingIndicators();
                ExternalPaymentService.handlePayment($scope.tdc, $scope.sections, $scope.adr).then((doingRedirect) => {
                    if (doingRedirect) {
                        hideProcessingIndicators();
                    } else {
                        // External Payment came back with an error since we aren't redirecting to the confirmation page
                        // The external payment error has already been set by the external payment service
                        // But if this is an adr ship immediate order we need to inform the user their adr was created
                        if ($scope.adr && $scope.adr.shipImmediate) {
                            $scope.sections.general.error.addErrorMessage('info',
                                {text: $scope.tdc.adrShipImmediateFailedErrorMessage});
                        }
                        initWaitingRoom();
                    }
                });
            } else {
                initWaitingRoom();
            }

            // ---------------------------------------------
            //
            //        Public Methods
            //
            // ---------------------------------------------
            $scope.getConfig = (config) => {
                return getCachedConfigField(config);
            };

            $scope.initAndGo = function() {
                $scope.isBusy = true;

                // IMPORTANT NOTE: This call MSUT be the isEnabledAsync and not the sychronous isEnabled
                // because the loading of the accertify flags has not happened yet and we need to make
                // sure the feature flag toggles are loaded first before initing the accertify beacon script
                retrieveProductionToggles().then((flags) => {
                    $scope.blockPointsPromoCombo = isEnabled('cx16-2785_points_promo');

                    if (isEnabled('cx8_380_accertify')) {
                        if (AccertifyFraudService.accertifyInMarketConfig(checkoutCfg)) {
                            AccertifyFraudService.initAccertify(checkoutCfg);
                            if (isEnabled('cx8_380_debugging')) {
                                console.log('CX8:\n\t', AccertifyFraudService.getTransactionID());
                            }
                        }
                    }
                });

                const simulatePromiseDependencies = [];
                OrderUtil.initOrders($scope, $rootScope, $timeout, $q, $http, nsUtil, simulatePromiseDependencies);
                DropShipUtil.initDropShip($scope);
                PaymentUtil.initPayments($scope);
                CartUtil.initCart($scope);
                PaymentUtil.injectPaymentComponent();
                // Special case for JP with Business Portfolio....
                if ($scope.order.simulateWithoutShipping) {
                    ShippingAddressUtil.initShippingAddresses($scope, nsUtil, nsShipping, []);
                    ShippingAddressUtil.injectShippingComponent();
                    CartUtil.initializeCart();
                    // For fixing the P1 production issue
                    $('#orderSummaryRoot').css('display', 'block');
                } else {
                    ShippingAddressUtil.initShippingAddresses(
                        $scope, nsUtil, nsShipping, simulatePromiseDependencies);
                    ShippingAddressUtil.injectShippingComponent();
                    loadCheckout();
                }
                $scope.cuotas = $scope.order.selectedPayment && $scope.order.selectedPayment.useInstallments ?
                    $scope.order.selectedPayment.getInstallmentSelectedNumber() :
                    1;

                setTimeout(function() {
                    if (nuskin && shopCfg.enableThreatMetrics) {
                        ThreatMatrixUtil.initThreatMatrixScriptUrl($scope, nsUtil);
                    }
                }, 2000);
            };

            $scope.showStoredCredentialsDialog = function() {
                getTermsOfUseText();
                $scope.storedCredentialsDialog = !$scope.storedCredentialsDialog;
            };

            $scope.initShippingAddresses = function() {
                ShippingAddressUtil.initShippingAddresses($scope, nsUtil, nsShipping, []);
                ShippingAddressUtil.injectShippingComponent();
            };

            $scope.setCaliforniaWarnings = function() {
                const address = $scope.order.selectedAddress;
                if (!address) {
                    return;
                } // exit early if there is no shipping address

                if ($scope.runConfig.country === 'US' && address.shippingState === 'CA') {
                    // Order is shipping to California; add warnings if order contains applicable SKUs;
                    const skuWarnings = window.californiaSkuWarnings || [];
                    const orderItems = CartService.getItemData({sapItems: true});
                    $scope.californiaWarnings = skuWarnings
                        .filter((s) => orderItems.some((item) => item.sku === s.sku))
                        .map((s) => s.warning)
                        .join('\n');
                } else {
                    $scope.californiaWarnings = null;
                }
            };

            /**
             * Load sticky headers and hide processing indicators once content has been loaded into DOM
             */
            $scope.$watch('contentLoaded', function(newValue) {
                if (newValue) {
                    $scope.buildStickyHeaders();
                    hideProcessingIndicators();
                    $scope.pointsEdited = false;
                    showPointsPaymentOptions();
                    $scope.orderHasAdr = CartService.getItemCnt({cartAdrItems: true}) > 0;
                    $scope.setCaliforniaWarnings();
                    $scope.sidebar = document.getElementById('checkoutSideBar');
                    if (nuskin.util.MobileUtils.isMobileLike()) {
                        $window.requestAnimationFrame(stickyScroll);
                    }
                }
            });

            /**
             * simulateWithoutShippingForJapan
             */
            function simulateWithoutShippingForJapan() {
                $scope.order.simulateWithoutShipping = true;
                $scope.saveSAPAddresstoProfile = true;
                CartUtil.initializeCart();
                // For fixing the P1 production issue
                $('#orderSummaryRoot').css('display', 'block');
            }

            $scope.buildStickyHeaders = function() {
                setTimeout(function() {
                    if (nuskin && StickyHeader && !$scope.busyHeader) {
                        // If we're inside AgeLoc, we need to watch a different scroll element
                        if (document.querySelector('.ageloc-wrap')) {
                            StickyHeaderStack.scrollWatch = '.ageloc-wrap';
                        }

                        StickyHeaderStack.reinitialize();

                        // const headerBoundary = new StickyHeaderBoundary('#header');

                        StickyHeaderStack.stackOffsetMobile = '#ns-header';

                        $scope.errorHeader = new StickyHeader('#checkoutErrorSummary .errorDialogue', {
                            customLeftAlignment: true, onClick: 'scrollToOrigin'
                        });
                        $scope.paymentError = new StickyHeader('#checkout-edit-payment .errorDialogue', {
                            customLeftAlignment: true, onClick: 'scrollToOrigin'
                        });
                        $scope.busyHeader = new StickyHeader('#busyHeader', {
                            customLeftAlignment: true, onClick: 'scrollToOrigin'
                        });
                        $scope.reviewError = new StickyHeader('#checkout-review-order .errorDialogue', {
                            customLeftAlignment: true, onClick: 'scrollToOrigin'
                        });

                        StickyHeaderStack.$stackProxy.addClass('ns-atomic');
                    }
                }, 5000);
            };

            /**
             * stickyScroll
             */
            function stickyScroll() {
                const sidebar = document.getElementById('checkoutSideBar');
                if (sidebar) {
                    const sideBarTop = sidebar.getBoundingClientRect().top;
                    const paymentSection = document.getElementById('checkout-payment-section');
                    const paymentBottom = paymentSection.getBoundingClientRect().bottom;
                    const adrSection = document.getElementById('checkout-adrOptions');
                    const adrBottom = adrSection.getBoundingClientRect().bottom;
                    const lastSectionBottom = (($scope.order && $scope.order.adr) || $scope.adr) ? adrBottom : paymentBottom;
                    const body = document.getElementsByTagName('body')[0];
                    const viewWidth = body.offsetWidth;
                    const viewHeight = window.innerHeight;

                    if (nuskin.util.MobileUtils.isMobileLike()) {
                        sidebar.removeAttribute('style');
                        if (viewHeight < viewWidth && viewWidth >= 767) {
                            $scope.stickySideBar.value = false;
                        } else if ((viewHeight - 60) < sideBarTop && !$scope.stickySideBar.value) {
                            $scope.stickySideBar.value = true;
                        } else if (lastSectionBottom < (viewHeight - 70)) {
                            $scope.stickySideBar.value = false;
                            $scope.slideUpOrderReview = false;
                        }

                        if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
                            $scope.apply();
                        }
                    }
                }
            }

            $window.addEventListener('scroll', (e) => {
                stickyScroll();
            });

            $window.addEventListener('touchmove', (e) => {
                stickyScroll();
            });

            $window.addEventListener('resize', () => {
                stickyScroll();
            });

            $window.addEventListener('orientationchange', () => {
                setTimeout(() => {
                    stickyScroll();
                }, 500);
            });

            $scope.$watch('sections.payment.edit', () => {
                // This is waiting for an animation to complete
                setTimeout(() => {
                    stickyScroll();
                }, 700);
            });

            $scope.$watch('slideUpOrderReview', () => {
                const body = document.getElementsByTagName('body')[0];
                if ($scope.slideUpOrderReview) {
                    body.classList.add('overflow-none');
                } else {
                    body.classList.remove('overflow-none');
                }
            });

            $scope.processBackToCart = function() {
                $('#mobile-processing').show();
                if (StickyHeaderStack) {
                    StickyHeaderStack.remove();
                }
                sessionStorage.setItem('appChangeSpinner', true);

                if ($scope.showPointsPaymentOptions) {
                    resetPointsAllocations();
                }
                CartService.goToCartPage($scope.getCartParams());
            };

            $scope.onLoadTerms = function() {
                util.sanitizeEmbeddedPage();
            };

            $scope.updateUserEmailOptInStatus = function() {
                // console.log("Email Opt In = " + $scope.emailOptIn);
                const userId = user.id;
                const countryCode = $scope.runConfig.country;
                try {
                    const dataObject = {'ID': userId, 'EmailStatus': 'normal', 'CountryCode': countryCode};

                    const extendedAccountUrl = urlCfg.extendedAccountUrl || '/account-service/api/v1/account/extended/';
                    $.ajax({
                        url: extendedAccountUrl + userId + '?eid=' + user.eid,
                        type: 'PUT',
                        data: JSON.stringify(dataObject),
                        crossDomain: true,
                        withCredentials: true,
                        contentType: 'application/json',
                        headers: {
                            'client_id': $scope.runConfig.clientId,
                            'client_secret': $scope.runConfig.clientSecret
                        },
                        success: function() {
                            console.log('Email Opt In flag updated successfully.');
                        },
                        error: function() {
                            console.log('Error updating email opt in flag.');
                        }
                    });
                } catch (err) {
                    console.error(err);
                }
            };

            // stuff for payWithPoints
            $scope.showPointsBalance = function() {
                return (CartService.getCartInfo().totalOrderPoints > 0);
            };

            $scope.pointsBalance = function() {
                const usedPoints = CartService.getCartInfo().totalOrderPoints;
                return $scope.remainingUserPoints(usedPoints);
            };

            $scope.remainingUserPoints = function(usedPoints) {
                let remainingPoints = 0;
                if (!$scope.isGuestCheckout && user) {
                    const userAvailablePoints = $scope.userAvailablePoints;
                    remainingPoints = userAvailablePoints - usedPoints;
                }
                return remainingPoints;
            };

            $scope.showingSpinner = function() {
                return !$scope.showEventMessageModal &&
                    ($scope.isBusy || ($scope.showSpinner && !$scope.contentLoaded) || $scope.shippingBusy);
            };

            $scope.hideBackToCartButton = function() {
                return ($scope.sections.shipping.adding ||
                    $scope.sections.shipping.editing ||
                    $scope.sections.shipping.selecting ||
                    $scope.sections.payment.adding ||
                    $scope.sections.payment.editing);
            };

            $scope.isInstallmentPaymentType = function(p) {
                if (p) {
                    switch (p.paymentTypeId) {
                        case PaymentType.DBS:
                        case PaymentType.UOB:
                        case PaymentType.MBB:
                        case PaymentType.PBB:
                        case PaymentType.CIMB:
                        case PaymentType.KBANK:
                        case PaymentType.BCA:
                        case PaymentType.BDO:
                        case PaymentType.APVN:
                        case PaymentType.CITI:
                        case PaymentType.HSBC:
                            return true;
                    }
                }
                return false;
            };

            // Pickup points and google maps related functionality.

            function getMarkerInfo(pup, pupIndex) {
                return `
                    <div ng-non-bindable="">
                        <div class="pickupPointInfo">
                            <h3 class="section-result-title">${pup.name}</h3>
                            <div class="pickupPointAddress">${pup.street}</div>
                            <div class="pickupPointAddress">${pup.city}</div>
                            <div class="pickupPointAddress">${pup.carrier}</div>
                            <label style="display: block; text-align: left;">${pup.openingHours}</label>
                            <button class="hit-solid thin"
                                onclick="window.selectPickupPoint(${pupIndex})">
                                ${$scope.tdc.pickupSelectLocationButton}
                            </button>
                        </div>
                    </div>
                `;
            }

            let map;
            $scope.updateMap = async () => {
                // Request needed libraries.
                // eslint-disable-next-line no-undef
                const {Map, InfoWindow} = await google.maps.importLibrary('maps');
                // eslint-disable-next-line no-undef
                const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary('marker');

                const bounds = $scope.order.pickupPoints.reduce((bounds, pup) => {
                    return bounds.extend({
                        lat: pup.latitude,
                        lng: pup.longitude
                    });
                // eslint-disable-next-line no-undef
                }, new google.maps.LatLngBounds());

                map = new Map(document.getElementById('pupMap'), {
                    zoom: 6,
                    mapId: 'pickUpLocations'
                });

                map.fitBounds(bounds);

                const infoWindow = new InfoWindow();
                $scope.order.pickupPoints.forEach((pup, pupIndex) => {
                    const pin = new PinElement({
                        glyph: `${pupIndex + 1}`,
                        borderColor: 'black',
                        background: '#4087AD',
                        glyphColor: 'white'
                    });
                    const marker = new AdvancedMarkerElement({
                        map: map,
                        position: {lat: pup.latitude, lng: pup.longitude},
                        content: pin.element
                        // title: "Uluru",
                    });
                    marker.addListener('click', () => {
                        infoWindow.close();
                        infoWindow.setContent(getMarkerInfo(pup, pupIndex));
                        infoWindow.open(marker.map, marker);
                    });
                });
                window.selectPickupPoint = $scope.selectPickupPoint;
            };

            $scope.$watch(function() {
                return $scope.showAvailablePickupPoints();
            }, function(newValue, oldValue) {
                if (newValue && !oldValue) {
                    $scope.updateMap();
                }
            });

            $scope.showAvailablePickupPoints = function() {
                let result = false;
                if (nsUtil.has($scope.order, 'selectedShippingMethod.Code')) {
                    result = PickupUtil.supports($scope.order.selectedShippingMethod.Code) &&
                        Array.isArray($scope.order.pickupPoints) &&
                        $scope.order.pickupPoints.length > 0 &&
                        !$scope.order.selectedPickupPoint &&
                        !$scope.sections.shipping.selecting &&
                        !$scope.sections.shipping.editing &&
                        !$scope.sections.shipping.adding &&
                        !$scope.isBusy &&
                        !$scope.editMode;
                }
                return result;
            };

            $scope.showNoPickupPointsFoundMessage = function() {
                let result = false;
                if (nsUtil.has($scope.order, 'selectedShippingMethod.Code')) {
                    result = PickupUtil.supports($scope.order.selectedShippingMethod.Code) &&
                        Array.isArray($scope.order.pickupPoints) &&
                        $scope.order.pickupPoints.length === 0 &&
                        !$scope.order.selectedPickupPoint &&
                        !$scope.sections.shipping.selecting &&
                        !$scope.sections.shipping.editing &&
                        !$scope.sections.shipping.adding &&
                        !$scope.isBusy && !$scope.editMode;
                }
                return result;
            };

            $scope.showSelectedPickupPoint = function() {
                let result = false;
                if (nsUtil.has($scope.order, 'selectedShippingMethod.Code')) {
                    result = PickupUtil.supports($scope.order.selectedShippingMethod.Code) &&
                        $scope.order.selectedPickupPoint &&
                        !$scope.sections.shipping.selecting &&
                        !$scope.sections.shipping.selecting &&
                        !$scope.sections.shipping.editing &&
                        !$scope.sections.shipping.adding &&
                        !$scope.isBusy &&
                        !$scope.editMode;
                }
                return result;
            };

            $scope.clearSelectedPickupPoint = function() {
                $scope.order.selectedPickupPoint = null;
                OrderManager.saveOrders();
            };

            $scope.selectPickupPoint = function(index) {
                $scope.order.selectedPickupPoint = $scope.order.pickupPoints[index];
                OrderManager.saveOrders();
            };

            $scope.shouldSelectPickupPoint = function() {
                let result = false;
                if (nsUtil.has($scope.order, 'selectedShippingMethod.Code')) {
                    result = PickupUtil.supports($scope.order.selectedShippingMethod.Code) && !$scope.order.selectedPickupPoint;
                }
                return result;
            };

            $scope.showPickupList = function() {
                $scope.pickupListSelected = true;
                $scope.pickupMapSelected = false;
            };

            $scope.showPickupMap = function() {
                $scope.pickupListSelected = false;
                $scope.pickupMapSelected = true;
            };

            // COM-2043: GA Event to fire when shipping section is completed
            $scope.$watch('sections.payment.pristine', () => {
                // If both shipping and billing sections are dirty - then we know the shipping is complete
                if (!$scope.sections.payment.pristine && !$scope.sections.shipping.pristine) {
                    $scope.gtmProducts = convertCartItemsToGtmProducts(CartService.getItemData({cartItems: true}));
                    events.publish(events.shop.CART_CHECKOUT, {
                        'ecommerce': {
                            'currencyCode': $scope.order.currencyCode, 'checkout': {
                                'actionField': {'step': 3, 'option': ''}, 'products': $scope.gtmProducts
                            }
                        }
                    });
                }
            });

            // COM-2043: GA Event to fire when payment section is completed
            $scope.$watch('sections.review.pristine', () => {
                // If both shipping and billing sections are dirty - then we know the shipping is complete
                if (!$scope.sections.review.pristine && !$scope.sections.payment.pristine) {
                    events.publish(events.shop.CART_CHECKOUT, {
                        'ecommerce': {
                            'currencyCode': $scope.order.currencyCode, 'checkout': {
                                'actionField': {'step': 4, 'option': $scope.order.selectedPayment ? $scope.order.selectedPayment.paymentTypeDescription : ''},
                                'products': $scope.gtmProducts
                            }
                        }
                    });
                }
            });

            // For a japanese romaji keyboard remove any non alpha numeric characters
            $scope.$watch('order.productDiscountCode', () => {
                if ($scope.order) {
                    $scope.order.productDiscountCode = $scope.order.productDiscountCode && $scope.order.productDiscountCode.toUpperCase().replace(/\W/g, '');
                }
            });

            $scope.$watch('order.shippingDiscountCode', () => {
                if ($scope.order) {
                    $scope.order.shippingDiscountCode = $scope.order.shippingDiscountCode && $scope.order.shippingDiscountCode.toUpperCase().replace(/\W/g, '');
                }
            });

            $scope.$watch('jpCouponCode', () => {
                $scope.jpCouponCode = $scope.jpCouponCode && $scope.jpCouponCode.toUpperCase().replace(/\W/g, '');
            });

            /**
             * apply
             *
             * @param {function} _callback
             */
            $scope.apply = (_callback) => {
                const callback = _callback || function() {
                };

                if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
                    $scope.$apply(callback);
                } else {
                    callback();
                }
            };

            // ---------------------------------------------
            //
            //        Private Methods
            //
            // ---------------------------------------------

            /**
             * convertCartItemsToGtmProducts
             *
             * @param {array} products
             * @return {Array}
             */
            function convertCartItemsToGtmProducts(products) {
                const gtmProducts = [];
                for (let i = 0; i < products.length; i++) {
                    const gtmProduct = {};
                    gtmProduct.id = products[i].sku;
                    gtmProduct.name = products[i].title;
                    gtmProduct.price = products[i].price;
                    gtmProduct.quantity = products[i].qty;
                    gtmProduct.coupon = '';
                    gtmProducts.push(gtmProduct);
                }
                return gtmProducts;
            }

            /**
             * checkForDowntime
             */
            function checkForDowntime() {
                if (!sessionStorage.getItem(MAINTENANCE_BYPASS)) {
                    // Check for downtime
                    nsDowntime.getDowntime(`${$scope.runConfig.language}_${$scope.runConfig.country}`).then(function() {
                        if (nsDowntime.isDown()) {
                            CartService.goToCheckoutPage({route: 'downtime'});
                        } else {
                            const goingDownInMin = nsDowntime.isGoingDownSoon();
                            if (goingDownInMin > 0 && $scope.tdc && $scope.tdc.downtimeText) {
                                $scope.sections.general.error.addErrorMessage('info', {
                                    text: $scope.tdc.downtimeText.replace('{0}', goingDownInMin), details: ''
                                });
                            }
                        }
                    });
                }
            }

            /**
             * loadCheckout
             */
            function loadCheckout() {
                const finish = function() {
                    $('#orderSummaryRoot').css('display', 'block');

                    if ($scope.shippingAddresses && $scope.shippingAddresses.length > 0) {
                        CartUtil.initializeCart();
                    } else if ($scope.runConfig.country === 'JP' && !$scope.isGuestCheckout) {
                        simulateWithoutShippingForJapan();
                    } else {
                        // No addresses found.  Open the shipping section for the user to enter an address.
                        $scope.sections.shipping.edit = true;
                        $scope.sections.shipping.pristine = false;
                        $scope.sections.cart.edit = false;
                        $scope.sections.cart.pristine = false;
                        $scope.contentLoaded = true;
                    }

                    // for analytics
                    events.publish(events.shop.CHECKOUT_USER_INFO, {
                        guest: $scope.isGuestCheckout,
                        addressOnProfile: ($scope.shippingAddresses && $scope.shippingAddresses.length > 0)
                    });
                    $scope.apply();
                };

                // Make sure we are ready to initialize.  If we have no addresses then we need to prompt the user for an address
                // before initialization.
                if ($scope.isGuestCheckout || $scope.shippingPromise) {
                    $scope.hidePointValue = true;

                    if ($scope.isPitchCart) {
                        PersonalOfferService.callShipping($scope.personalOffer.sapId, $scope.personalOffer.pitchID);
                    }

                    if (user && !nsUtil.isEmpty(user.eid)) {
                        $scope.shippingPromise.then(function() {
                            finish();
                        });
                    } else {
                        finish();
                    }
                } else {
                    $('#orderSummaryRoot').css('display', 'block');
                }
            }

            // ---------------------------------------------
            //
            //        Runtime code
            //
            // ---------------------------------------------

            /**
             * setCustomerTypeMessage
             * @param {object} $scope
             */
            function setCustomerTypeMessage($scope) {
                const user = UserService.getUser();
                $scope.customerTypeMessage = '';
                if (user && typeof $scope.tdc !== 'undefined') {
                    if (user.isDistributor() && $scope.tdc.distributorReviewMessage) {
                        $scope.customerTypeMessage = $scope.tdc.distributorReviewMessage;
                    } else if (user.isPreferredCustomer() && $scope.tdc.preferredCustomerReviewMessage) {
                        $scope.customerTypeMessage = $scope.tdc.preferredCustomerReviewMessage;
                    } else if (user.isCustomer() && $scope.tdc.customerReviewMessage) {
                        $scope.customerTypeMessage = $scope.tdc.customerReviewMessage;
                    }
                } else if ($scope.tdc.customerReviewMessage) {
                    $scope.customerTypeMessage = $scope.tdc.customerReviewMessage;
                }
            }

            /**
             * handleInvalidAddressSearch
             * @param {string} string
             */
            function handleInvalidAddressSearch(string) {
                $scope.isBusy = false;
                $scope.googleMapsError = true;
                if ($scope.sections.shipping.edit) {
                    $scope.sections.shipping.error.addErrorMessage('info', {text: string});
                } else if ($scope.sections.payment.edit) {
                    $scope.sections.payment.error.addErrorMessage('info', {text: string});
                }
            }

            /**
             * enableMapsErrorBtn
             */
            function enableMapsErrorBtn() {
                $scope.googleMapsError = false;
            }

            /**
             * showPointsPaymentOptions
             */
            function showPointsPaymentOptions() {
                // ADR Override and ADR One-Time Orders in markets that support points redemption
                const isAdrPointsEnabled = adpCfg.enablePayWithPoints && AdrService.isAdrOverride();

                // Standard Orders in markets that support points redemption for such
                const isOrderPointsEnabled = checkoutCfg.enablePointsRedemption && AccountManager.isLoggedIn() && !$scope.runConfig.assessmentApp;

                if (isAdrPointsEnabled || isOrderPointsEnabled) {
                    $scope.showPointsPaymentOptions = true;
                    $scope.detailsIcon = 'nuskin:icon-gift';
                    $scope.orderDetailsHeader = $scope.tdc.redeemPointsHeader || $scope.tdc.orderDetails;
                    $scope.hasRedeemableItems = true;
                    $scope.sections.cart.pristine = false;

                    const hasRedeemedItems = CartService.getItemData({sapItems: true})
                        .some((item) => item.redeem);

                    if (!hasRedeemedItems) {
                        $scope.sections.cart.edit = false;
                    }

                    if (!$scope.tdc.purchaseQtyWithPoints) {
                        $scope.tdc.purchaseQtyWithPoints = 'Purchase {qty} items with points';
                    }
                    const splitPurchaseQtyWithPoints = $scope.tdc.purchaseQtyWithPoints.split('{qty}');
                    $scope.purchaseQtyWithPointsStr0 = splitPurchaseQtyWithPoints[0];
                    $scope.purchaseQtyWithPointsStr1 = splitPurchaseQtyWithPoints.length > 1 ? splitPurchaseQtyWithPoints[1] : '';

                    if (!$scope.tdc.purchaseWithQtyPoints) {
                        $scope.tdc.purchaseWithQtyPoints = 'Purchase with {qty} points';
                    }
                    const splitPurchaseWithQtyPoints = $scope.tdc.purchaseWithQtyPoints.split('{qty}');
                    $scope.purchaseWithQtyPointsStr0 = splitPurchaseWithQtyPoints[0];
                    $scope.purchaseWithQtyPointsStr1 = splitPurchaseWithQtyPoints.length > 1 ? splitPurchaseWithQtyPoints[1] : '';

                    $scope.cartPointsSubtotal = getPointsPriceTotal(false);
                    $scope.pointsTotal = getPointsPriceTotal();

                    // Add "old redeem quantity" value to items in DOM so that redeem quantity can be tracked and reverted
                    // if user attempts to apply more points than they have available.
                    // CartService.getItemData({sapItems: true}).forEach(item => item._qtyRedeemOld = item.qtyRedeemWithPoints);

                    // Show options to redeem points only if order contains one or more redeemable items;
                    // Also, if order is not ADR Override, show options only if order has non-zero total PSV
                    $scope.hasRedeemableItems = CartService.getItemData({sapItems: true})
                        .some((item) => !item.isAdr && item.points > 0) && (AdrService.isAdrOverride() || getOrderTotalPsv() > 0);

                    // Observe changes to selected shipping method, to cancel "Pay With Points" if method is non-applicable
                    $scope.$watch('order.selectedShippingMethod', () => {
                        if (!$scope.isPWPShippingMethod($scope.order.selectedShippingMethod)) {
                            $scope.order.shippingPayWithPoints = false;
                            $scope.pointsTotal = getPointsPriceTotal();
                        }
                    });

                    AdrService.getAdrPoints().then((points) => {
                        $scope.apply(() => {
                            $scope.userAvailablePoints = points;
                            if (points === 0) {
                                $scope.showPointsPaymentOptions = false;
                                $scope.apply();
                            }
                        });
                    }).catch(() => {
                        $scope.userAvailablePoints = 0;
                        $scope.showPointsPaymentOptions = false;
                        $scope.apply();
                    });
                }
            }

            /**
             * initListeners
             */
            function initListeners() {
                // since subscriptions remained from each time the controller is
                //  called unsubscribe needs to be called beforehand.

                events.unsubscribe(events.shop.CHECKOUT_FOCUS);
                events.unsubscribe(events.shop.ADR_SHIP_DAYS_CHANGED);
                events.unsubscribe(events.errors.INVALID_SEARCH_ADDRESS);
                events.unsubscribe(events.errors.NUMBER_STREET_ADDRESS);
                events.unsubscribe(events.shop.NEW_GOOGLE_MAPS_SEARCH);
                events.unsubscribe(events.shop.ORDER_UPDATED);

                events.subscribe(events.shop.CART_EVENT_PRICE_UPDATED, (activeEvents) => {
                    if (activeEvents != undefined && $scope.shippingState === 'complete') {
                        $scope.showEventMessageModal = true;
                        $scope.apply();
                    }
                });

                events.subscribe(events.shop.ADR_SHIP_DAYS_CHANGED, function() {
                    $scope.apply(function() {
                        $scope.sections.adrOptions.pristine = true;
                        AdrUtil.initAdrSection();
                    });
                });
                events.subscribe(events.shop.CHECKOUT_FOCUS, function(elementId) {
                    $timeout(function() {
                        $(`#${elementId}:visible`).focus();
                    }, 500);
                });
                events.subscribe(events.errors.INVALID_SEARCH_ADDRESS, function(ele) {
                    handleInvalidAddressSearch($scope.tdc.addressSearchError);
                    ele.addEventListener('keyup', enableMapsErrorBtn);
                });
                events.subscribe(events.errors.NUMBER_STREET_ADDRESS, function() {
                    handleInvalidAddressSearch($scope.tdc.numberAddressFirstError);
                });
                events.subscribe(events.shop.NEW_GOOGLE_MAPS_SEARCH, function() {
                    $scope.googleMapsError = false;
                    $scope.googleMapsChanged = true;
                });

                events.subscribe(events.shop.ORDER_UPDATED, function(orders) {
                    if ($scope.order) {
                        $scope.apply();
                    }
                });

                events.subscribe(events.authentication.LOGIN_COMPLETE, () => {
                    $scope.user = UserService.getUser();
                });
            }

            /**
             * start
             */
            function start() {
                if (!needToHandleExternalPayment || !ExternalPaymentService.isValidStatus(ExternalPaymentService.getUrlPaymentStatus())) {
                    // remove external payment next order flag
                    localStorage.removeItem(EXTERNAL_PAYMENT_NEXT_ORDER);
                    // Get the cart and make sure there are items in it, else return to the cart.
                    if (CartService.getItemCnt() === 0) {
                        // If there are no items in cart
                        if ($scope.isPitchCart) {
                            window.location = $scope.personalOffer.landingPageURL;
                        } else {
                            CartService.goToCartPage($scope.getCartParams());
                        }
                        return;
                    }

                    checkForDowntime();
                    // checkForEmailOptIn();

                    $scope.modalShown1 = false;
                    $scope.modalShown2 = false;
                    $scope.toggleModal1 = function(options) {
                        ModalUtil.toggleModal(options, $('#checkout-edit-shipping'), $scope.modalShown1);
                        $scope.modalShown1 = !$scope.modalShown1;
                    };

                    $scope.cancelDeleteShipping = function(id) {
                        $scope.deleteShippingDialog = false;
                        $('#deleteShippingDialogDiv' + id).hide();
                    };

                    $scope.cancelDeletePayment = function(id) {
                        $scope.deletePaymentDialog = false;
                        $('#deletePaymentDialogDiv' + id).hide();
                    };

                    $scope.setDeletePaymentDialogId = function(id) {
                        $scope.deletePaymentDialogId = id;
                    };

                    $scope.setDeleteShippingDialogId = function(id) {
                        $scope.deleteShippingDialogId = id;
                    };

                    $scope.showGuestTermsConditions = function() {
                        return $scope.isGuestCheckout && checkoutCfg.enableGuestTermsAndConditions && $scope.tdc.guestCustomerReviewMessage;
                    };
                    $scope.disablePlaceMyOrderButton = function() {
                        return $scope.forceDisableOrderButton ||
                            !($scope.sections.readyToOrder($scope.isBusy)) ||
                            $scope.paymentState !== 'complete' ||
                            ($scope.sections.payment.promo || PromoCodeOffers.hasUnAppliedPromoCodes()) ||
                            $scope.shippingState !== 'complete' ||
                            ($scope.showGuestTermsConditions() && !$scope.guestTermsConditionsCheckbox) ||
                            ($scope.showDownConvertTncCheckbox && !$scope.downConvertTncChecked);
                    };
                    $scope.placeMyOrder = function(disabled) {
                        if (disabled) {
                            return;
                        }
                        // Remove any query params before we create an order so if they go to external payment
                        // and click the browser back button we don't try to process the query params again
                        $location.search({});

                        if (!$scope.disablePlaceMyOrderButton()) {
                            // if pickup shipping method && no location selected
                            if (!$scope.order.selectedShippingMethod || PickupUtil.supports($scope.order.selectedShippingMethod.Code) &&
                                !$scope.order.selectedPickupPoint) {
                                $scope.updateEdit('shipmethod');
                                return;
                            }
                            if (typeof $scope.isCcvMet === 'function' && !$scope.isCcvMet()) {
                                $scope.updateEdit('payment');
                                events.publish(events.shop.CHECKOUT_FOCUS, 'ccv');
                                return;
                            }
                            hideProcessingIndicators();
                            $scope.createOrder('createButton');

                            if (checkoutCfg.enabled) {
                                let loyaltyPointsUsed = '0';
                                let loyaltyPointsEarned = '0';
                                if ($scope.order.orderTotals.pointsUsed && !isNaN($scope.order.orderTotals.pointsUsed) && $scope.order.orderTotals.pointsUsed > 0) {
                                    loyaltyPointsUsed = $scope.order.orderTotals.pointsUsed;
                                }

                                if ($scope.orderLoyaltyEarnings && !isNaN($scope.orderLoyaltyEarnings) && $scope.orderLoyaltyEarnings > 0) {
                                    loyaltyPointsEarned = $scope.orderLoyaltyEarnings;
                                }

                                // Track amount of points used. 0 (Integer) is not recognized by Google Analytics and shows up as
                                // "(not set)". It must be coerced to a String.
                                events.publish(events.loyalty.LOYALTY_ORDER_INFO, {
                                    'context': 'orderSummary', loyaltyPointsUsed, loyaltyPointsEarned
                                });
                            }
                        }
                    };

                    // Redirect to order confirmation if we have a completed order
                    if (OrderManager.getCompletedOrder()) {
                        $scope.isBusy = false;
                        StickyHeaderStack.remove();
                        CartService.goToCheckoutPage({route: 'orderconfirmation'});
                        return;
                    }

                    setCustomerTypeMessage($scope);

                    if (AdrService.isAdrOverride()) {
                        AdrService.getAdrDetails(AdrService.getAdrOverrideId(), {forceRefresh: false, fullAdrDetail: true})
                            .then((adr) => {
                                $scope.overriddenADR = adr;
                                $scope.initAndGo();
                            });
                    } else {
                        $scope.initAndGo();
                    }

                    // If we have processed an external payment we check if we need to display an error.
                    if (ExternalPaymentService.hasErrorMessageForCheckoutPage()) {
                        $scope.isBusy = false;
                        ExternalPaymentService.displayErrorMsg($scope.sections);
                    }

                    if (checkoutCfg.enabled && $scope.order && $scope.order.orderTotals) {
                        $scope.orderLoyaltyEarnings = CartService.calculateLoyaltyEarnings(undefined, true);
                    }
                }
            }

            function injectWaitingRoomComponent() {
                const container = document.getElementById('waitingRoom');
                const wrInformation = $scope.tdc.wrInformation || '';
                const wrPosition = $scope.tdc.wrPosition || '';
                const wrTime = $scope.tdc.wrTime || '';
                container.innerHTML = `<ns-waiting-room
                    id="waiting-room"
                    queue="${getCachedConfigField('queueName')}"
                    information="${wrInformation}"
                    position="${wrPosition}"
                    waittime="${wrTime}"
                    serving>
                </ns-waiting-room>`;
            }

            /**
             * initWaitingRoom
             *
             * During a high load sales event the waiting room component will inform the user they are in line to checkout.
             * When the waiting room status changes to closed we allow the user to continue and we load checkout by calling the start function.
             */
            function initWaitingRoom() {
                // start waiting room
                injectWaitingRoomComponent();
                const el = document.getElementById('waiting-room');
                el.addEventListener('status-changed', function(data) {
                    console.log('Waiting room:', el.status);
                    if (el.status === 'closed') {
                        $scope.showSpinner = true;
                        start();
                    } else {
                        $scope.apply(function() {
                            $scope.showSpinner = false;
                        });
                    }
                });
            }

            /**
             * getTermsOfUseText
             */
            function getTermsOfUseText() {
                if (!$scope.storedCredentialsTOC) {
                    const baseUrl = $scope.runConfig.fbBaseUrl ? $scope.runConfig.fbBaseUrl : $scope.runConfig.baseUrl;
                    const {language, country} = $scope.runConfig;
                    let url = `${baseUrl}/content/nuskin/${language}_${country}/corporate/terms.3.json`;
                    if (language === 'ja' && country === 'JP') {
                        url = `${baseUrl}/content/markets/${language}_${country}/corporate/terms.3.json`;
                    }
                    $http.get(url)
                        .then(function(response) {
                            $scope.storedCredentialsTOC = response.data['jcr:content'].bodyContent.text_857.text;
                        });
                }
            }

            function getAgreedToTermsFlag(user) {
                $scope.showTncCheckbox = false;

                if (getCachedConfigField('showDownConvertAgreementCheckbox') && user.isPreferredCustomer()) {
                    AgreementService.downConvertAgreedToTerms(user.id).then((hasAgreed) => {
                        $scope.showDownConvertTncCheckbox = !hasAgreed;
                        $scope.apply();
                    });
                }
            }
        };

        // If checkout is running in the mobile app in a webview we need to load the cart first.  Otherwise continue loading checkout.
        if (!window.ReactNativeWebView) {
            await initCheckout();
        } else {
            let checkoutInitialized = false;
            // This event is published by the receiver.js file in the ns-shop repository
            // The receiver.js handles initializing the cart from the mobile app
            events.getValue(events.mobile.NATIVE_INITIALIZING, async (status) => {
                if (status === false && !checkoutInitialized) {
                    checkoutInitialized = true;
                    await initCheckout();
                }
            }, true);
        }
    }]);
